import React from "react";
import CommonMigration from "./CommonMigration";

const PharmaMigration = () => {
  const api = {
    check: "migration/pharmacy/drug-migration/",
    start: "migration/pharmacy/drug-migration/",
    progress: "migration/pharmacy/drug-migration/",
    download: "migration/pharmacy/drug-migration/",
  };

  return <CommonMigration moduleName="Pharmacy" api={api} />;
};

export default PharmaMigration;
